module.exports = __webpack_public_path__ + "static/img/1-8.9a9d599e.png";